import { NoTransformConfigurationError } from './transformers/NoTransformConfigurationError.mjs';

/**
 * @internal
 */
function message() {
    NoTransformConfigurationError("protobuf.message");
}
/**
 * @internal
 */
function decode() {
    NoTransformConfigurationError("protobuf.decode");
}
/**
 * @internal
 */
function assertDecode() {
    NoTransformConfigurationError("protobuf.assertDecode");
}
/**
 * @internal
 */
function isDecode() {
    NoTransformConfigurationError("protobuf.isDecode");
}
/**
 * @internal
 */
function validateDecode() {
    NoTransformConfigurationError("protobuf.validateDecode");
}
/**
 * @internal
 */
function encode() {
    NoTransformConfigurationError("protobuf.encode");
}
/**
 * @internal
 */
function assertEncode() {
    NoTransformConfigurationError("protobuf.assertEncode");
}
/**
 * @internal
 */
function isEncode() {
    NoTransformConfigurationError("protobuf.isEncode");
}
/**
 * @internal
 */
function validateEncode() {
    NoTransformConfigurationError("protobuf.validateEncode");
}
/**
 * @internal
 */
function createDecode() {
    NoTransformConfigurationError("protobuf.createDecode");
}
/**
 * @internal
 */
function createIsDecode() {
    NoTransformConfigurationError("protobuf.createIsDecode");
}
/**
 * @internal
 */
function createAssertDecode() {
    NoTransformConfigurationError("protobuf.createAssertDecode");
}
/**
 * @internal
 */
function createValidateDecode() {
    NoTransformConfigurationError("protobuf.createValidateDecode");
}
/**
 * @internal
 */
function createEncode() {
    NoTransformConfigurationError("protobuf.createEncode");
}
/**
 * @internal
 */
function createIsEncode() {
    NoTransformConfigurationError("protobuf.createIsEncode");
}
/**
 * @internal
 */
function createAssertEncode() {
    NoTransformConfigurationError("protobuf.createAssertEncode");
}
/**
 * @internal
 */
function createValidateEncode() {
    NoTransformConfigurationError("protobuf.createValidateEncode");
}

export { assertDecode, assertEncode, createAssertDecode, createAssertEncode, createDecode, createEncode, createIsDecode, createIsEncode, createValidateDecode, createValidateEncode, decode, encode, isDecode, isEncode, message, validateDecode, validateEncode };
//# sourceMappingURL=protobuf.mjs.map
